// Import model
import { ProjectNoteCondition } from '../models/ProjectNoteCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ProjectNoteIndexedFields } from '../models/ProjectNoteIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ProjectNoteIndexedFieldsSerializer } from './ProjectNoteIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ProjectNoteCondition - handles JSON serialization and deserialization with type validation
 */
export class ProjectNoteConditionSerializer {
  /**
   * Deserializes a JSON string into a ProjectNoteCondition instance
   */
  static deserialize(json: string): ProjectNoteCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ProjectNoteCondition instance
   */
  static fromObject(obj: any): ProjectNoteCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ProjectNoteCondition');
    }


    const instance: ProjectNoteCondition = {
      fieldName: obj['fieldName'] as ProjectNoteIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ProjectNoteCondition instances
   */
  static deserializeArray(json: string): ProjectNoteCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ProjectNoteCondition instance to a JSON string
   */
  static serialize(instance: ProjectNoteCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ProjectNoteCondition instance to a plain object
   */
  static toObject(instance: ProjectNoteCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ProjectNoteCondition instances to a JSON string
   */
  static serializeArray(instances: ProjectNoteCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
